// extracted by mini-css-extract-plugin
module.exports = {"arrowDown":"arrow-module--arrow--down--37jXG","arrowLeft":"arrow-module--arrow--left--1Ti-I","arrowUp":"arrow-module--arrow--up--2Dwx5"};